<app-navigation
  class="pcoded-navbar"
  [topPadding]="searchOn ? bannerHeight + navBarHeight : bannerHeight"
  [id]="navHidden ? 'apcoded-navbar-hiden' : ''"
  [ngClass]="{
    'navbar-collapsed': navCollapsed,
    'theme-horizontal': this.gradientConfig['layout'] === 'horizontal',
    'mob-open': navCollapsedMob
  }"
  (onNavMobCollapse)="navMobClick()"
></app-navigation>

<app-nav-bar
  class="navbar pcoded-header navbar-expand-lg navbar-light p-0"
  (onNavCollapse)="navCollapseClick()"
  (onNavHeaderMobCollapse)="navMobClick()"
  (afterViewInit)="navBarHeight = $event ? $event : 0"
  [isSubscriptionExpired]="isSubscriptionExpired"
  [companyId]="companyId"
  [navCollapsed]="navCollapsed"
  style="background: var(--color-bg-nav-bar);"
></app-nav-bar>


<div
  class="pcoded-main-container h-100"
  [id]="navHidden ? 'pcoded-full' : ''"
  [style.top.px]="containerTop"
>
  <div
    class="pcoded-wrapper container page-stretched d-flex flex-column justify-content-between custom-container"
    [id]="navHidden ? 'pcoded-wrapper-cover' : ''"
    [ngClass]="{
      container:
        this.gradientConfig.layout === 'horizontal' &&
        this.gradientConfig.subLayout === 'horizontal-2',
      'pcoded-content-collapsed': navCollapsed
    }"
  >
    <div [class.has-notification-banner]="!!bannerType" class="pcoded-content">
      <div>
        <div class="pcoded-inner-content">
          <div class="main-body">
            <div class="page-wrapper">
              <app-breadcrumb></app-breadcrumb>
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <footer class="footer card footer-custom">
        <div>
          <div class="row text-muted">
            <div class="col-md-6 col-sm-12 text-start">
              <p class="mb-0">
                <a
                  href="https://inventoryoptimizer.ai/"
                  target="_blank"
                  class="text-muted"
                  rel=noopener
                  ><strong>&copy;&nbsp;Inventory Optimizer</strong></a
                >
              </p>
            </div>
            <div class="col-md-6 col-sm-12 text-md-end text-sm-start">
              <ul class="list-inline">
                <li class="list-inline-item">
                  <a
                    class="text-muted"
                    href="https://support.inventoryoptimizer.ai"
                    target="_blank"
                    rel=noopener
                    >Support</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    class="text-muted"
                    href="https://inventoryoptimizer.ai/privacy-policy/"
                    target="_blank"
                    rel=noopener
                    >Privacy</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    class="text-muted"
                    href="https://inventoryoptimizer.ai/terms/"
                    target="_blank"
                    rel=noopener
                    >Terms</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</div>

<app-configuration></app-configuration>


